<template>
  <div>
    <Snackbar :SnackBarComponent="SnackBarComponent" />
    <v-container fluid fill-height>
      <v-layout align-center justify-center>
        <v-flex>
          <v-row align="center" justify="center" class="mt-n6">
            <v-col cols="12" xs="12" sm="12" md="5">
              <v-card-text>
                <v-card class="elevation-6" tile>
                  <v-toolbar
                    dense
                    color="blueColorVariant9"
                    class="pa-0 elevation-0 white--text fontsize13px font-weight-bold"
                    >MY PROFILE
                    <v-spacer />
                    <v-btn
                      icon
                      small
                      dark
                      @click="$router.push('/PlateLookUp')"
                      class="mr-1"
                      ><v-icon>mdi-close</v-icon></v-btn
                    ></v-toolbar
                  >
                  <div class="mt-8" align="center">
                    <v-icon
                      size="40px"
                      color="grey"
                      v-if="
                        !CurrentUserDetailsObj.user_image_url ||
                        CurrentUserDetailsObj.user_image_url === 0
                      "
                      class="pa-2"
                      >mdi-account</v-icon
                    >
                    <v-img
                      v-else
                      :src="PoliceImage"
                      flat
                      width="80px"
                      height="70px"
                      class="text-center ImageRadius mt-n6 pa-0"
                    >
                    </v-img>
                    <v-form ref="form">
                      <v-col
                        class="px-0"
                        :class="$vuetify.breakpoint.lg ? 'px-16' : 'px-6'"
                        align="center"
                      >
                        <v-text-field
                          v-model="CurrentUserDetailsObj.user_name"
                          dense
                          outlined
                          class="black--text font-weight-bold"
                          :class="$vuetify.breakpoint.lg ? 'mx-6' : 'mx-0'"
                          :readonly="isEditable('user_name')"
                          label="Name"
                        >
                          <template v-slot:append
                            ><v-btn small icon @click="ReadOnly('user_name')"
                              ><v-icon small>mdi-pencil</v-icon></v-btn
                            ></template
                          ></v-text-field
                        >
                        <v-text-field
                          v-model="CurrentUserDetailsObj.user_email_id"
                          dense
                          outlined
                          class="black--text font-weight-bold"
                          :class="$vuetify.breakpoint.lg ? 'mx-6' : 'mx-0'"
                          readonly
                          label="Email Id"
                        ></v-text-field>
                        <v-text-field
                          v-model="CurrentUserDetailsObj.user_phone_number"
                          dense
                          outlined
                          class="black--text font-weight-bold"
                          :class="$vuetify.breakpoint.lg ? 'mx-6' : 'mx-0'"
                          readonly
                          label="Phone Number"
                        ></v-text-field>
                        <v-text-field
                          v-model="CurrentUserDetailsObj.badge_number"
                          dense
                          outlined
                          class="black--text font-weight-bold"
                          :class="$vuetify.breakpoint.lg ? 'mx-6' : 'mx-0'"
                          :readonly="isEditable('badge_number')"
                          :rules="[
                            (v) => !!v || 'Required',
                            (v) =>
                              /^(?=[a-zA-Z0-9@._%+-]{0,30}$)[0-9]{0,64}$/.test(
                                v
                              ) || 'Invalid',
                          ]"
                          label="Badge Number"
                          ><template v-slot:append
                            ><v-btn small icon @click="ReadOnly('badge_number')"
                              ><v-icon small>mdi-pencil</v-icon></v-btn
                            ></template
                          ></v-text-field
                        >
                        <v-text-field
                          v-model="CurrentUserDetailsObj.precinct_phone_number"
                          dense
                          outlined
                          class="black--text font-weight-bold"
                          :class="$vuetify.breakpoint.lg ? 'mx-6' : 'mx-0'"
                          :rules="[
                            (v) => !!v || 'Required',
                            (v) =>
                              /^(?=[a-zA-Z0-9@._%+-]{0,30}$)[0-9]{0,64}$/.test(
                                v
                              ) || 'Invalid',
                          ]"
                          :readonly="isEditable('precinct_phone_number')"
                          label="Station Ph.no"
                          ><template v-slot:append
                            ><v-btn
                              small
                              icon
                              @click="ReadOnly('precinct_phone_number')"
                              ><v-icon small>mdi-pencil</v-icon></v-btn
                            ></template
                          ></v-text-field
                        >
                        <v-text-field
                          v-model="CurrentUserDetailsObj.precinct"
                          dense
                          outlined
                          class="black--text font-weight-bold"
                          :class="$vuetify.breakpoint.lg ? 'mx-6' : 'mx-0'"
                          :readonly="isEditable('precinct')"
                          label="Station"
                          ><template v-slot:append
                            ><v-btn small icon @click="ReadOnly('precinct')"
                              ><v-icon small>mdi-pencil</v-icon></v-btn
                            ></template
                          ></v-text-field
                        >

                        <v-select
                          v-model="CurrentUserDetailsObj.police_zone"
                          dense
                          outlined
                          class="black--text font-weight-bold"
                          :class="$vuetify.breakpoint.lg ? 'mx-6' : 'mx-0'"
                          :readonly="isEditable('police_zone')"
                          :items="
                            Array.from(Array(6).keys()).map(
                              (i) => 'Zone' + (i + 1)
                            )
                          "
                          label="Zone"
                          ><template v-slot:append
                            ><v-btn small icon @click="ReadOnly('police_zone')"
                              ><v-icon small>mdi-pencil</v-icon></v-btn
                            ></template
                          ></v-select
                        >
                      </v-col>
                    </v-form>
                  </div>
                  <v-row justify="center">
                    <v-card-actions>
                      <v-btn
                        :loading="loading"
                        small
                        dark
                        color="blueColorVariant9"
                        class="mt-n3"
                        @click="UpdateGetUsermethod()"
                        >Save</v-btn
                      >
                    </v-card-actions>
                  </v-row>
                </v-card>
              </v-card-text>
            </v-col>
          </v-row>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>
<script>
import { updateProfileDetails } from "@/mixins/Methods/updateProfileDetails.js";
import { GetCurrentUserDetails } from "@/mixins/GetCurrentUserDetails.js";
import { GenerateS3URL } from "@/mixins/ImageUpload.js";
import Snackbar from "@/components/Extras/Snackbar.vue";
export default {
  props: {},
  components: {
    Snackbar,
  },
  mixins: [updateProfileDetails, GenerateS3URL, GetCurrentUserDetails],
  data: () => ({
    PoliceImage: "",
    cardHeight: 0,
    CurrentUserDetailsObj: {},
    SnackBarComponent: {},
    editableFields: {
      user_name: true,
      badge_number: true,
      precinct_phone_number: true,
      precinct: true,
      user_phone_number: "",
      police_zone: "",
    },
    loading: false,
  }),
  watch: {},
  async mounted() {
    this.CurrentUserDetailsObj = this.$store.getters.get_current_user_details;
    if (
      this.CurrentUserDetailsObj.user_image_url != null ||
      this.CurrentUserDetailsObj.user_image_url != ""
    ) {
      if (
        !this.CurrentUserDetailsObj.user_image_url.includes(
          "https://makeithomesafe.s3.us-east-1.amazonaws.com"
        )
      ) {
        const url = this.CurrentUserDetailsObj.user_image_url;
        const parts = url.split("/");
        const path = parts.slice(parts.indexOf("police_profiles")).join("/");
        // console.log("pathg", path);
        this.PoliceImage = await this.GenerateS3URLMethods(`${path}`);
      } else {
        const filename = this.CurrentUserDetailsObj.user_image_url
          .split("?")[0]
          .split("/")
          .pop();
        const decodedFileName = decodeURIComponent(filename);
        this.PoliceImage = await this.GenerateS3URLMethods(decodedFileName);
      }
    }
  },
  methods: {
    ReadOnly(field) {
      this.editableFields[field] = false;
    },
    isEditable(field) {
      return this.editableFields[field];
    },
    async UpdateGetUsermethod() {
      if (this.$refs.form.validate()) {
        this.loading = true;
        let inputParams = {
          badge_number: this.CurrentUserDetailsObj.badge_number,
          // user_phone_number: this.CurrentUserDetailsObj.PhoneNumber,
          precinct: this.CurrentUserDetailsObj.precinct,
          precinct_phone_number:
            this.CurrentUserDetailsObj.precinct_phone_number,
          user_id: this.CurrentUserDetailsObj.user_id,
          user_name: this.CurrentUserDetailsObj.user_name,
          police_zone: this.CurrentUserDetailsObj.police_zone,
        };
        let result = await this.updateProfileDetailsMethod(inputParams);
        this.loadingDefaultState = false;
        if (result == "SUCCESS") {
          this.CurrentUserDetailsObj =
            this.$store.getters.get_current_user_details;
        }
        this.GetCurrentUser();
        this.SnackBarComponent = {
          SnackbarVmodel: true,
          SnackbarColor: "green",
          Top: true,
          SnackbarText: "Profile Updated Successfully",
        };
      } else {
        this.SnackBarComponent = {
          SnackbarVmodel: true,
          SnackbarColor: "red",
          Top: true,
          SnackbarText: "Please Provide Valid Details",
        };
      }
    },
  },
};
</script>
